<script>
	import { drawerOpen, navbarMenu, showBack, back, navbarTitle, showNavbarImage } from './../../store.js';
	import { createEventDispatcher, onMount } from 'svelte'
	import Hamburger from './Hamburger.svelte'
	import { fade, fly } from 'svelte/transition';

	export let animateIt
	export let webapp = false;
	

	let animate = false
	let navImageReady = false;
	let y = -50;
	let ready = false;
	
	//let clicked = false;

	if(animateIt){
		animate =true;
	}

	onMount(()=>{
		if(webapp){
			y = -75;
			console.log('webapp header')
		}

		if(navBarImage){

			const navImage = new Image();
			
			navImage.load = ()=>{

				navImageReady = true;
			}


			navImage.src=navBarImageUrl;

		}

		ready = true;
	})

	async function leftAction() {
		if($showBack){


			//check if override is active
			if(!window.backOverRide){
				back.set(true);
				window.history.back();
			}else{
				console.log('using back over ride')
				window.backOverRide();
			}
		
		}else{
			//hamburgers https://jonsuh.com/hamburgers/
			

			if($drawerOpen===true){
				drawerOpen.set(false);
				console.log('close');
			}else{
				drawerOpen.set(true);
				console.log('open');
			}
		}
	}
	
	
</script>


<header style="background-color: {appBackground.hexBackground};" >
	{#if ready}
		<div class="navbar" class:animate class:webapp>
			<!-- <div class="navbar" class:animate in:fly={{delay:0, y: -50, duration: 800, opacity:1 }} class:webapp> -->
			<div class="left" on:mousedown={leftAction}>
				{#if $showBack}
					<div class="svg-icon-back" in:fade={{duration:300}}></div>
				{:else}
					{#if $navbarMenu}
						<div in:fade={{duration:300}}>
							<Hamburger/>
						</div>
					{/if}
				{/if}
			</div>

			{#if navBarImage && $showNavbarImage}
				<span class="title"><img id="navbar-image" src={navBarImageUrl} class="navbar-image" alt="{$navbarTitle}" style="max-height:32px" in:fade /></span>
			{:else}
				<span class="title">{@html $navbarTitle}</span>
			{/if}

			<div class="right"></div>
		</div>
	{/if}
</header>

<style> 
	@keyframes slideInFromLeft {
		0% {
			transform: translateX(100%);
		}
		100% {
			transform: translateX(0%);
		}
	}
	header{
		position: -webkit-sticky;
		position: sticky;
    	top: 0;
	}
    span {
		color: #fff;
		min-width:60%;
		max-width:60%;
		text-align: center;
		font-weight: bold;
		font-size: 1.2em;
		display: -webkit-box;
		line-clamp: 1;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;  
		overflow: hidden;


	}
	.navbar{
		background-color:var(--user-color);
		min-height: 50px;
		max-height: 50px; 
		display: flex;
		align-items:center;
		align-content: center;
		justify-content:flex-start;
		width:100%;
		text-align: center;
	}
	
	
	.navbar.webapp{
	
		min-height: 75px;
		max-height: 75px; 

	}
	.navbar .left,.navbar .right{
		min-width:20%; 
		color: #fff;
		display: flex;
		align-items:center;
		align-content: center;
		justify-content:flex-start;
	} 
	.navbar.webapp .left,.navbar.webapp .right,	.navbar.webapp .title{
		padding-top:25px;
	} 
	.navbar .left{
		transition-duration: .2s;
		transition-property: color;
	}

	.navbar .left:active{
		color:rgba(255,255,255,.5);
	}
	.navbar-image{
		
	}
	
	.svg-icon-back{
		height:35px;
		margin-top: 5px;
	} 
	.navbar.animate .left span{
		animation: 0.5s ease-out 0s 1 slideInFromLeft;
	}
	.navbar.animate p{
		animation: 0.5s ease-out 0s 1 slideInFromLeft;
	}

	.left,.right{
		cursor: pointer;
	}
</style>